import React from 'react';
import useCoveyAppState from '../../hooks/useCoveyAppState';
import usePlayersInTown from '../../hooks/usePlayersInTown';


/**
 * Displays the current player's TicTacToe game states, including number of wins, losses, and ties.
 */
export default function TicTacToeStatistics(): JSX.Element {
  const playerInfo = useCoveyAppState();
  const playerID = playerInfo.myPlayerID;
  const playerList = usePlayersInTown();
 
  const currentPlayer = playerList.find(player => player.id === playerID);
  
  if (currentPlayer) {
    const { ticTacToeStats } = currentPlayer;
    return <div>
      <h3>Wins: {ticTacToeStats.wins}</h3>
      <h3>Losses: {ticTacToeStats.losses}</h3>
      <h3>Ties: {ticTacToeStats.ties}</h3>
    </div>
  }
  return <div> No Player Found! {playerInfo.userName} could not be found. </div>
}